















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { DepartmentManager } from '@/models/admin/department';
import { UserModel } from '@/models/admin/users';
import { Base } from '@/components/common/base';
import { departmentService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class ManagerSavePage extends Base {
  public stores: any[];
  public manager: DepartmentManager = {
    id: '',
    email: '',
    approvalLimit: 0,
    isNoLimit: false,
  };
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;
  public paymentTypes: any[];
  public departmentId: string = '';
  public noLimit: boolean = false;
  public users: UserModel[] = [];
  public disableSubmitButton: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.departments.managers',
        params: { id: this.departmentId, storeId: this.storeId.toString() },
      });
    }
    if (methodName === 'submitManager') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.submitManager();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName === '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('departments.btnBack'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('departments.btnBack'),
        click: 'backToList',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'departments');

    this.storeId = Number(this.$route.params.storeId);
    this.setFields();
    if (this.$route.params.id) {
      this.departmentId = this.$route.params.id;
      this.getUsers();
    }

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.addWatchers();
  }

  public addWatchers() {
    this.$watch('manager.isNoLimit', (newVal, oldVal) => {
      const approvalLimitField = this.formFields.find((f) => {
        return f.key === 'approvalLimit';
      });
      if (approvalLimitField) {
        approvalLimitField.templateOptions.required = !newVal;
        approvalLimitField.required = !newVal;
        approvalLimitField.templateOptions.disabled = newVal;
        approvalLimitField.templateOptions.validations = newVal
          ? ''
          : 'required';
      }
      if (newVal && this.manager.id) {
        this.form.$valid = true;
      }
    });
    this.$watch('manager.id', (newVal, oldVal) => {
      if (newVal && this.manager.isNoLimit) {
        this.form.$valid = true;
      }
    });
  }

  public validateManager(): Vue & { validate: () => boolean } {
    return this.$refs.managerForm as Vue & { validate: () => boolean };
  }

  public async submitManager(): Promise<void> {
    if (this.validateManager().validate()) {
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        if (this.manager.isNoLimit) {
          this.manager.approvalLimit = -1;
        }
        const userDetails = this.users.filter((user) => {
          return user.id === this.manager.id;
        });
        if (userDetails.length > 0) {
          this.manager.email = userDetails[0].email;
        }

        if (Number(this.manager.approvalLimit) === 0) {
          this.showAlert(false, this.$t('departments.alertApproveLimitNotZero'));
          return;
        }

        await departmentService.saveManagerAsync(
          this.manager,
          this.departmentId,
          this.storeId
        );
        this.showAlert(true, this.$t('departments.alertSaveManager'));
        this.$router.push({
          name: 'admin.departments.managers',
          params: { id: this.departmentId },
        });
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'id',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          counter: 500,
          label: this.$t('departments.managerFields.selectManager') as string,
          disabled: false,
          items: this.users,
          text: 'email',
          value: 'id',
          altag: 'Select Manager',
          loading: false,
        },
      },
      {
        key: 'approvalLimit',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 7,
          label: this.$t('departments.managerFields.approvalLimt') as string,
          required: true,
          disabled: false,
          type: 'number',
          loading: false,
          rules: [
            v => this.requiredValidate('Approval Limit', v, this.manager.isNoLimit)
          ]
        },
      },
      {
        key: 'isNoLimit',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
          label: this.$t('departments.managerFields.noLimit') as string,
          disabled: false,
          validations: '',
          loading: false,
        },
      },
    ];
  }
  public async getUsers(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const departmentUsers = await departmentService.getDepartmentUsersAsync(
        this.departmentId,
        this.storeId
      );
      this.users = departmentUsers.results;
      this.setFields();
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }

  public requiredValidate(fieldName: string, val: string, limit: boolean) {
    if (!val && !limit) {
      return `The ${fieldName} Field is required`;
    }

    if (val && !limit && Number(val) < 0) {
      return `The ${fieldName} should be Greated than 0`;
    }

    try {
      if (val == 'undefined' || val == 'null' && !limit)
        return `The ${fieldName} Field is required`;
    }
    catch { }

    return true;
  }

}
